export const MENU = [
    {
        "id": "i774k21f-9t0m",
        "icon": ['fas', 'home'],
        "class": "bg-color-eighth",
        "titre": "accueil",
        "path": "/",
        "modal": false,
    },
    {
        "id": "b384e21f-8d7a",
        "icon": ['fas', 'sms'],
        "class": "bg-color-eighth",
        "titre": "nouveau sms",
        "path": "/nouveau-sms",
        "modal": false,
    },
    {
        "id": "fa3cc51d-6aee",
        "icon": ['fas', 'at'],
        "class": "bg-color-ninth",
        "titre": "Nouvel email",
        "path": "/nouvel-email",
        "modal": false,
    },
    {
        "id": "fa3cc51d-6aee",
        "icon": ['fas', 'history'],
        "class": "bg-color-ninth",
        "titre": "historique sms",
        "path": "/historique-sms",
        "modal": false,
    },
    {
        "id": "11800d25-i9o6",
        "icon": ['fas', 'users'],
        "class": "bg-color-third",
        "titre": "mes contacts",
        "path": "/mes-contacts",
        "modal": false,
    },
    {
        "id": "83849d20-a9e6",
        "icon": ['fas', 'user-circle'],
        "class": "bg-color-third",
        "titre": "mon compte",
        "path": "/mon-compte",
        "modal": false,
    },
    {
        "id": "77324ac6-dc83",
        "icon": ['fas', 'info-circle'],
        "class": "bg-color-seventh",
        "titre": "à propos",
        "path": "/apropos",
        "modal": false,
    },
    {
        "id": "26eff7a8-79de",
        "icon": ['fas', 'file-signature'],
        "class": "bg-color-sixth",
        "titre": "nous contacter",
        "path": "/contact",
        "modal": false,
    },
    {
        "id": "d853bfa0-6c96",
        "icon": ['fas', 'globe'],
        "class": "bg-color-second",
        "titre": "pays pris en charge",
        "path": "/pays-disponible",
        "modal": true,
    },
    {
        "id": "e953iow8-3m81",
        "icon": ['fas', 'tags'],
        "class": "bg-color-second",
        "titre": "tarification",
        "path": "/tarification",
        "modal": true,
    },
]



// WEBPACK FOOTER //
// ./src/data/menu.js